'use strict';
const RestUtils = require('utils/RestUtils'),
    {merge} = require('lodash/object'),
    get = require('lodash/object').get,
    LocaleUtils = require('utils/LocaleUtils'),
    Constants = require('constants/AppConstants'),
    Security = require('./Security').auth,
    hostApi = process.env.URL_API;

const LocaleServiceImpl = {

    saveSettingModal(applicantConfiguration, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/applicants/settings');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(applicantConfiguration));
    },

    getApplicantSetting(success, failure) {
        const ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/applicants/settings');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(Security.getCurrentCountry(), 'cca2'));
        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(Security.getCurrentCurrency(), 'code'));
        ajax.send();
    },

    getCurrentLocaleInfo(onSuccess, onFailure) {
        this.getIP(hostIp => {
            const ip = (hostIp && hostIp.ip ? hostIp.ip : '');
            this.getCurrentCountry(ip, countryInfo => {
                this.getTimeZoneInfo(ip, timeZoneInfo => {
                    const allResponses = merge({}, countryInfo, timeZoneInfo);
                    onSuccess(allResponses);
                }, onFailure);
            }, onFailure);
        }, onFailure);
    },

    getTimeZoneInfo(hostIp, onSuccess, onError) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.responseText));
            });
        }, onError);
        const myUrl = 'http://ip-api.com/json?ip=' + hostIp;
        ajax.open('GET', myUrl);
        ajax.send();
    },


    getCurrentCountry(hostIp, onSuccess, onError) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.responseText));
            });
        }, onError);
        const myUrl = 'http://www.geoplugin.net/json.gp?ip=' + hostIp;
        ajax.open('GET', RestUtils.getCORSSafeUrl(myUrl));
        ajax.send();
    },

    getIP(onSuccess, onError) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.responseText));
            });
        }, onError);
        ajax.open('GET', 'https://jsonip.com');
        ajax.send();
    }
};

module.exports = LocaleServiceImpl;



/** WEBPACK FOOTER **
 ** ./src/services/LocaleServiceImpl.js
 **/